// Libraries
import React from 'react';

// Supermove

// App
import WarningModal from '@shared/design/components/Modal/SmallModal/WarningModal';

const DiscardEmailModal = ({
  isOpen,
  handleClose,
  handleDiscardEmail,
}: {
  isOpen: boolean;
  handleClose: () => void;
  handleDiscardEmail: () => void;
}) => {
  return (
    <WarningModal
      isOpen={isOpen}
      title={'Discard Draft?'}
      message={'Your email content will not be saved and cannot be undone.'}
      handlePrimaryAction={() => {
        handleDiscardEmail();
        handleClose();
      }}
      handleSecondaryAction={handleClose}
      primaryActionText={'Confirm'}
      secondaryActionText={'Cancel'}
    />
  );
};

export default DiscardEmailModal;
